const ID_PATH_EXTRACT = /\/([^/]+$)/;

/**
 * Return default JSON pointer path from schema $id
 */
export function determinePropertyPathFromId({ $id }: { $id: string | undefined }): string {
    if ($id) {
        const path_match = ID_PATH_EXTRACT.exec($id);
        const path_name = (path_match && path_match[1]) || $id || '';

        return `${path_name}#`; // e.g. Review#/properties
    }

    return `#`;
}
